/**
 * Created by Victor Rojo on 22/5/19.
 */
import {Component, Input, OnDestroy} from '@angular/core';

import { WidgetService }            from "../../widget/Widget.service";
import {IPlaceDataChangeService} from "../../IPlaceDataChange.service";
import {WidgetStatusChangeAware} from "../base-widget/WidgetStatusChangeAware";
import {SimpleGadget} from "../../gadget/Gadget";
import {SSEElement} from "../../element/Element";
import {IndicatorWidget} from "../../widget/Widget";


@Component({
  selector: 'indicator',
  templateUrl: './Indicator.component.html',
  styleUrls: ['./Indicator.component.css']
})
export class IndicatorComponent extends WidgetStatusChangeAware{

  gadgets: SimpleGadget[];
  @Input()
  columns: number;
  subscriptions: any[] = [];
  elements:any = {};
  indicatorPercentage:number = 0;
  indicatorValue:number = 0;
  indicatorUnit:string = "";
  indicatorMinSegment:number = 0;
  indicatorMaxSegment:number = 100;
  footerLeftValue:number = 0;
  footerLeftUnit:string = "";
  footerLeftLabel:string = "";
  footerRightValue:number = 0;
  footerRightUnit:string = "";
  footerRightLabel:string = "";

  indicatorValueElementId:string;
  indicatorMaxValueElementId:string;
  footerLeftElementId:string;
  footerRightElementId:string;
  thresholdConfig:any;


  constructor(private widgetService: WidgetService,
              private iPlaceDataChangeService1: IPlaceDataChangeService) {
    super(iPlaceDataChangeService1);

    this.subscriptions.push(this.iPlaceDataChangeService1.elementChange$.subscribe( (element:SSEElement) => {
      let gadgetElement = this.elements[element.id];
      if ( gadgetElement ) {
        gadgetElement.name = element.name;
        gadgetElement.value = element.value;
        gadgetElement.status = element.status;
        gadgetElement.updateDate = element.updateDate;
        gadgetElement.lastStatusChange = element.lastStatusChange;

        if ( this.indicatorValueElementId == element.id ) {
          this.indicatorValue = Number(element.value);
          this.indicatorPercentage = this.indicatorMaxSegment ? this.indicatorValue * 100 / this.indicatorMaxSegment : 0;
        } else if ( this.indicatorMaxValueElementId == element.id ) {
          this.indicatorMaxSegment = Number(element.value);
          this.indicatorPercentage = this.indicatorMaxSegment ? this.indicatorValue * 100 / this.indicatorMaxSegment : 0;
        } else if ( this.footerLeftElementId == element.id ) {
          this.footerLeftValue = Number(element.value);
        } else if ( this.footerRightElementId == element.id ) {
          this.footerRightValue = Number(element.value);
        }
      }
    }));

    this.thresholdConfig = {
      '0': {color: '#F86C6B'},
      '30': {color: '#EF811F'},
      '50': {color: '#03c561'}
    };
  }

  get widget(): IndicatorWidget {
    return this._widget as IndicatorWidget;
  }

  @Input()
  set widget(indicatorWidget: IndicatorWidget) {
    this._widget = indicatorWidget;
    this.updateValues(indicatorWidget);
  }

  private updateValues(indicatorWidget: IndicatorWidget){
    this.elements = {};
    indicatorWidget.gadgets
      .forEach(gadget => gadget.elements.forEach(element => this.elements[element.elementId] = element));
    this.gadgets = indicatorWidget.gadgets.sort( (g1,g2) => {
      if ( g1.gadgetOrder == g2.gadgetOrder) {
        return g1.gadgetOrder - g2.gadgetOrder;
      }
      return g1.gadgetOrder - g2.gadgetOrder;
    });
    if ( this.gadgets[0] != null && this.gadgets[0].elements[0] && this.gadgets[1] != null && this.gadgets[1].elements[0]) {
      let value = Number(this.gadgets[0].elements[0].value);
      let total = Number(this.gadgets[1].elements[0].value);
      this.indicatorMaxSegment = total;
      this.indicatorValue = value;
      this.indicatorUnit = this.gadgets[0].literal;
      this.indicatorPercentage = total ? value * 100 / total : 0;
      this.indicatorValueElementId = this.gadgets[0].elements[0].elementId;
      this.indicatorMaxValueElementId = this.gadgets[1].elements[0].elementId;
    }
    if ( this.gadgets[2] != null && this.gadgets[2].elements[0] ){
      this.footerLeftValue = Number(this.gadgets[2].elements[0].value);
      this.footerLeftUnit = this.gadgets[2].literal;
      this.footerLeftLabel = this.gadgets[2].tagTitle;
      this.footerLeftElementId = this.gadgets[2].elements[0].elementId;
    }
    if ( this.gadgets[3] != null && this.gadgets[3].elements[0] ){
      this.footerRightValue = Number(this.gadgets[3].elements[0].value);
      this.footerRightUnit = this.gadgets[3].literal;
      this.footerRightLabel = this.gadgets[3].tagTitle;
      this.footerRightElementId = this.gadgets[3].elements[0].elementId;
    }
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
